export default __webpack_public_path__ + "static/media/SlidesBelarus.c52313d0.pdf";